import React from 'react';

export const DBImpSide = ({ DBBlueprintTable, table, add, selectSide, missingPrimaryKey, PRIMARY_KEY }) => {

  let isPrimary_keyUniqueInTable = true;
  if(DBBlueprintTable[PRIMARY_KEY] != undefined) {
    let testArray = [];
    DBBlueprintTable[PRIMARY_KEY].table.forEach(v => testArray.includes(v) ? isPrimary_keyUniqueInTable = false : testArray.push(v));
  };

  let sideContent =
    <div className='flex-dir-column' style={{ flex: 9}}>
      {selectSide}
      <div className='overflow flex-dir-column' >
        { 
          Object.keys(table).map((field, index) => {
            return(
              <div style={{ flex: 0, flexDirection: 'row', alignItems: 'center' }} key={field + index}>
                <div className='dot' style={{background: DBBlueprintTable[field] ? field === PRIMARY_KEY ? isPrimary_keyUniqueInTable ? '#fff' : '#f11' : DBBlueprintTable[field].table.length > 1 ? '#f11' : '#fff' : '#ccc'}}></div>
                <div style={{ flex: 0 }}>{field}</div>
              </div>
            );
          })
        }
      </div>
    </div>

  return(
    <div className='result-panel shadow'>
      <div className='result-header right shadow'>
        <p>Intitulés</p>
      </div>
      <div className='side-content flex-dir-column'>
        {sideContent}
        <div className='flex-dir-column'>
          {
            !!missingPrimaryKey.length
            ? <div className='flex-dir-column' style={{ paddingTop: 5, margin: 5, borderTopWidth: 2, borderTopColor: '#ccc', borderTopStyle: 'solid'}}>
                <div style={{ marginBottom: 10}}>
                  Chaque table utilisée doit avoir la clef histolitt_v2 renseignée.
                </div>
                <div className='flex-dir-column'  style={{ marginLeft: 10}}>
                  Histolitt_v2 manquant dans :
                  <ul>
                    {missingPrimaryKey.map(m => <li>- {m.replace(/amp;/g,'')}</li>)}
                  </ul>
                </div>
              </div>
            : null
          }
          <div style={{ display: 'block', margin: 'auto'}}>
            <button className='regular-button' id='send-batch' disabled={!!missingPrimaryKey.length}  onClick={() => add()}>
              Valider
            </button>
          </div>
        </div>
      </div>
      
    </div>
  );
};
  